const API_BASE_URL = 'https://ecommerce-uhzl.onrender.com';

export { API_BASE_URL };
